export const allToleName = [
    {
        nepali: "हरैचा बजार पश्चिम (हस्पिटल रोड) ",
        english: "Hospital road",
        value: "hospital_road",
    },
    {
        nepali: "हरैचा बजार पश्चिम (हुलाकि मार्ग)",
        english: "Hulaki marg",
        value: "hulaki_marg",
    },
    {
        nepali: "हरैचा बजार पश्चिम (हाटखोला मार्ग)",
        english: "Hatkhola marg",
        value: "hatkhola_marg",
    },
    {
        nepali: "हरैचा बजार पश्चिम (ईलाका प्रहरी सडक )",
        english: "Ilaka police road",
        value: "ilaka_police_road",
    },
    {
        nepali: "हरैचा बजार पुर्वटोल",
        english: "Haraicha purwa",
        value: "haraicha_purwa",
    },
    {
        nepali: "हरैचा बजार",
        english: "Haraicha bazzaar",
        value: "haraicha_bazaar",
    },
    {
        nepali: "तिम्सिना डाडाटोल",
        english: "Timsina dadatole",
        value: "timsina_dadatole",
    },
    { nepali: "संगीत चोक", english: "sangit chowk", value: "sangit_chowk" },

    {
        nepali: "जनमैत्री मार्ग",
        english: "janamaitri marg",
        value: "janamaitri_marg",
    },
    { nepali: "लक्ष्मीपुर टोल", english: "Laxmipur", value: "laxmipur" },
    { nepali: "क्याम्पा टोल", english: "campa", value: "campa" },
    { nepali: "खोरिया टोल", english: "Khoriya", value: "khoriya" },
    { nepali: "पशुपति टोल", english: "pashupati", value: "pashupati" },
    {
        nepali: "कुमार गाउँ स्कुल चौक",
        english: "kumar gaun ",
        value: "kumar_gaun",
    },

    {
        nepali: "सिमल डाडा टोल",
        english: "simal danda",
        value: "simal_danda",
    },
    { nepali: "कार्की टोल", english: "karki", value: "karki" },
    { nepali: "सुक्रबारे", english: "sukrabare", value: "sukrabare" },

    {
        nepali: "माथिल्लो सितुमारी टोल",
        english: "situmari tol",
        value: "situmari_tol",
    },
    {
        nepali: "तल्लो  सितुमारी टोल",
        english: "tallo situmari",
        value: "tallo_situmari",
    },
    {
        nepali: "सितुमारी धामी बस्नेत टोल",
        english: "situmari_dhami",
        value: "situmari_dhami",
    },

    { nepali: "बानडाडा टोल", english: "Bandanda", value: "bandanda" },
    { nepali: "इटाभट्टा टोल", english: "Itabhaatta", value: "itabhaatta" },
    {
        nepali: "डागी टोल ( मदन आश्रित मार्ग )",
        english: "dangi tol",
        value: "dangi_tol",
    },
    {
        nepali: "डागी टोल (मदन आश्रित मार्ग देखि लक्षिण लक्ष्मीपुर सम्म) ",
        english: "dangi tol laxmipur",
        value: "dangi_tol_laxmipur",
    },
    { nepali: "लक्ष्मीपुर बेलेपुर सडक ", english: "Belepur", value: "belepur" },
    { nepali: "प्रतिटोल ", english: "prati tol", value: "prati_tol" },
    { nepali: "मास्टर टोल ", english: "master tl", value: "master_tl" },
    {
        nepali: "हरैचा टोल पचाम ",
        english: " haraincha pachan",
        value: "haraincha_pachan",
    },
    { nepali: "धाबीटोल मार्ग ", english: " Dhabitol", value: "dhabitol" },
    { nepali: "टनकपुर टोल ", english: " tanakpur", value: "tanakpur" },
    { nepali: "मुस्लिम टोल ", english: " muslim tol 1", value: "muslim_tol_1" },
    {
        nepali: "पचाम नयाँ बेलपुर टोल ",
        english: " pacham belpur",
        value: "pacham_belpur",
    },
    {
        nepali: "पचाम स्कुल टोल ",
        english: " pacham school",
        value: "pacham_school",
    },
    {
        nepali: "जलेश्वर टोल ",
        english: " jaleshwor tol",
        value: "jaleshwor_tol",
    },
    { nepali: "पचाम ", english: " pacham", value: "pacham" },
    {
        nepali: "तिम्सिना टोल खदम ",
        english: " timsina_khadam",
        value: "timsina_khadam",
    },
    { nepali: "ढकाल टोल ", english: " dhakal tol 1", value: "dhakal_tol_1" },
    { nepali: "खदम ", english: " khadam", value: "khadam" },
    {
        nepali: "कार्की टोल खदम उपकार चोक खदम ",
        english: " karki tol",
        value: "karki_tol",
    },
    {
        nepali: "कार्की टोल खदम ",
        english: " karki tol khadam",
        value: "karki_tol_khadam",
    },
    {
        nepali: "हवल्दार टोल खदम ",
        english: " hawaldar tol",
        value: "hawaldar_tol",
    },
    {
        nepali: "hawaldar_tol ",
        english: " hawaldar tol",
        value: "hawaldar_tol",
    },
    {
        nepali: "पचान थान टोल ",
        english: " pacham than tol",
        value: "pacham_than_tol",
    },
    { nepali: "ऐलानपुर", english: "alaanpur tol", value: "alaanpur_tol" },
    { nepali: "मझुवा", english: "mujhuwa", value: "mujhuwa_tol" },
    { nepali: "भगत टोल", english: "bhagat tol", value: "bhagat_tol" },
    { nepali: "बेलडाँगी टोल", english: "beladagi tol", value: "beladagi_tol" },
    { nepali: "मालती टोल", english: "maalti tol", value: "maalti_tol" },
    {
        nepali: "लालबस्ती टोल",
        english: "laalbasti tol",
        value: "laalbasti_tol",
    },
    { nepali: "खोरिया टोल", english: "koriya tol", value: "koriya_tol" },
    { nepali: "उफैलिया टोल", english: "ufailiya tol", value: "ufailiya_tol" },
    {
        nepali: "उफैलिया झाँगर टोल",
        english: "ufailiya jhagar tol",
        value: "ufailiya_jhagar_tol",
    },
    {
        nepali: "मृगौलिया बजार टोल",
        english: "mirgauliya bajar tol",
        value: "mirgauliya_bajar_tol",
    },
    { nepali: "लापटोली", english: "laapatoli", value: "laapatoli" },
    { nepali: "हिमाल चोक", english: "himal chok", value: "himal_chok" },
    {
        nepali: "कराईवाना टोल",
        english: "karaiwana tol",
        value: "karaiwana_tol",
    },
    {
        nepali: "तल्लो कराईवाना",
        english: "talo karaiwana",
        value: "talo_karaiwana",
    },
    { nepali: "जोगियारे टोल", english: "gogiyare tol", value: "gogiyare_tol" },
    { nepali: "खोटाङगे टोल", english: "khotang tol", value: "khotang_tol" },
    {
        nepali: "बेलडागी स्कुल टोल",
        english: "beldaagi school tol",
        value: "beldaagi_school_tol_1",
    },
    {
        nepali: "जोगियारे  पुर्ब टोल",
        english: "jogiyare purb toll",
        value: "jogiyare_purb_toll",
    },
    { nepali: "फुलबारी टोल", english: "fulbaari tol", value: "fulbaari_tol_1" },
    { nepali: "सुब्बा टोल", english: "fulbaari", value: "fulbaari_tol" },
    {
        nepali: "गोलापरासी टोल",
        english: "Golaaparaasi toll",
        value: "golaaparaasi_toll",
    },
    { nepali: "बिशाल मार्ग", english: "Bisal marga", value: "bisal_marga" },
    {
        nepali: "पत्थर घट्ट टोल",
        english: "Pathar ghata tol",
        value: "pathar_ghata_tol",
    },
    {
        nepali: "पत्थर घट्ट टावर टोल",
        english: "pathar ghata tawor tol",
        value: "pathar_ghata_tawor_tol",
    },
    {
        nepali: "गछिया बजार",
        english: "gachhiya bajaar",
        value: "gachhiya_bajaar",
    },
    { nepali: "शान्ति टोल", english: "santhi tol", value: "santhi_tol" },
    {
        nepali: "लक्ष्मी नारायण टोल",
        english: "laxmi naraayan tol",
        value: "laxmi_naraayan_tol",
    },
    { nepali: "नमुना टोल", english: "namunaa tol", value: "namunaa_tol" },
    {
        nepali: "वेलगाछी टोल",
        english: "belgaachhi tol",
        value: "belgaachhi_tol",
    },
    { nepali: "त्रिजुगा टोल", english: "trijugaa tol", value: "trijugaa_tol" },
    { nepali: "आम्झोकी टोल", english: "aaamjoki tol", value: "aaamjoki_tol" },
    { nepali: "मालती टोल", english: "maalati tol", value: "maalati_tol" },
    { nepali: "वाइचोक टोल", english: "waichhok tol", value: "waichhok_tol" },
    {
        nepali: "लिम्बु डाडा टोल",
        english: "limbu dhada tol",
        value: "limbu_dhada_tol",
    },
    {
        nepali: "लाल वस्ती टोल",
        english: "lal basti tol",
        value: "lal_basti_tol",
    },
    {
        nepali: "घेरावानी टोल",
        english: "geraawaani tol",
        value: "geraawaani_tol",
    },
    {
        nepali: "शेषनारायण टोल",
        english: "seshnaaraayan tol",
        value: "seshnaaraayan_tol",
    },
    {
        nepali: "मनकामना टोल",
        english: "manakaamana tol",
        value: "manakaamana_tol",
    },
    { nepali: "रेडक्रस टोल", english: "redcross tol", value: "redcross_tol" },
    { nepali: "नयाँ टोल", english: "nayaa tol", value: "nayaa_tol" },
    {
        nepali: "शान्तासिटौला घर उतर डाडा टोल",
        english: "santashitaula ghar utar dhada tol",
        value: "santashitaula_ghar_utar_dhada_tol",
    },
    {
        nepali: "लोचनी चौधरी टोल",
        english: "lochani chhaudari tol",
        value: "lochani_chhaudari_tol",
    },
    {
        nepali: "चिचरबना खाप टोल",
        english: "chichrbana khaap tol",
        value: "chichrbana_khaap_tol",
    },
    { nepali: "पशुपति टोल", english: "pasupati tol", value: "pasupati_tol" },
    { nepali: "आइतबार टोल", english: "aaitabare tol", value: "aaitabare_tol" },
    { nepali: "इराक टोल", english: "irak tol", value: "irak_tol" },
    {
        nepali: "बीचबाध त्रिजुगा",
        english: "bichbaada trijugaa",
        value: "bichbaada_trijugaa",
    },
    {
        nepali: "लालिगुरास टोल",
        english: "laliguras tol",
        value: "laliguras_tol",
    },
    {
        nepali: "अनुकुलनगर टोल",
        english: "anukulanagar tol",
        value: "anukulanagar_tol",
    },
    {
        nepali: "बुद्ध गंगा टोल",
        english: "budha ganga tol",
        value: "budha_ganga_tol",
    },
    { nepali: "बासबारी टोल", english: "basbari tol", value: "basbari_tol" },
    { nepali: "चरिगुवा टोल", english: "chariguwa tol", value: "chariguwa_tol" },
    {
        nepali: "मातृभुमि टोल",
        english: "maatribhumi tol",
        value: "maatribhumi_tol",
    },
    {
        nepali: "गौरी गाउँ टोल",
        english: "gouri gaau tol",
        value: "gouri_gaau_tol",
    },
    {
        nepali: "बडहरा खाप टोल",
        english: "badahara khap tol",
        value: "badahara_khap_tol",
    },
    {
        nepali: "बुद्ध नगर टोल",
        english: "budha nagar tol",
        value: "budha_nagar_tol",
    },
    {
        nepali: "नयाँ टोलि  टोल",
        english: "naya toli tol",
        value: "naya_toli_tol",
    },
    { nepali: "हवेली टोल", english: "haweli tol", value: "haweli_tol" },
    { nepali: "सिदार्थ टोल", english: "sidartha tol", value: "sidartha_tol" },
    {
        nepali: "चरिगुवा टोल",
        english: "chariguwa tol 1",
        value: "chariguwa_tol_1",
    },
    { nepali: "बलियो टोल", english: "baliyo tol", value: "baliyo_tol" },
    {
        nepali: "पानि टयाङकि टोल",
        english: "pani tanki tol",
        value: "pani_tanki_tol",
    },
    { nepali: "चेतनशील टोल", english: "chetansil tol", value: "chetansil_tol" },
    { nepali: "मंगलदीप टोल", english: "mangaldip tol", value: "mangaldip_tol" },
    { nepali: "उन्नति टोल", english: "unaanti tol", value: "unaanti_tol" },
    { nepali: "बडहरा टोल", english: "badahara tol", value: "badahara_tol" },
    { nepali: "शिवालय टोल", english: "siwalaya tol", value: "siwalaya_tol" },
    {
        nepali: "भोलेश्वर टोल",
        english: "bholeswor tol",
        value: "bholeswor_tol",
    },
    { nepali: "मुनाल मार्ग", english: "munal tol", value: "munal_tol" },
    { nepali: "गैरी टोल", english: "gauri tol", value: "gauri_tol" },
    { nepali: "तेलिया टोल", english: "teliya tol", value: "teliya_tol" },
    {
        nepali: "सिमल डाडा  टोल",
        english: "simal dadha tol",
        value: "simal_dadha_tol",
    },
    { nepali: "त्रिबेणी टोल", english: "tribeni tol", value: "tribeni_tol" },
    {
        nepali: "५ बिध्ये टोल",
        english: "pacha bidya tol",
        value: "pacha_bidya_tol",
    },
    {
        nepali: "सुन्दर बलिया टोल विकास  संस्था",
        english: "sundar baliya tol bikas sasthan",
        value: "sundar_baliya_tol_bikas_sasthan",
    },
    {
        nepali: "अमर ज्योति टोल विकास  संस्था",
        english: "amar joty tol bikas sasthan",
        value: "amar_joty_tol_bikas_sasthan",
    },
    {
        nepali: "शान्ति  टोल विकास  संस्था",
        english: "santi tol bikas sasthan",
        value: "santi_tol_bikas_sasthan",
    },
    {
        nepali: "पाथीभरा  टोल विकास  संस्था",
        english: "paathivara tol bikas sasthan",
        value: "paathivara_tol_bikas_sasthan",
    },
    {
        nepali: "मिलिजुली  टोल विकास  संस्था",
        english: "milijuli tol bikas sasthan",
        value: "milijuli_tol_bikas_sasthan",
    },
    {
        nepali: "सिदार्थ  टोल विकास  संस्था",
        english: "sidartha tol bikas sasthan",
        value: "sidartha_tol_bikas_sasthan",
    },
    {
        nepali: "फुलबारी  टोल विकास  संस्था",
        english: "fulbari tol bikas sasthan",
        value: "fulbari_tol_bikas_sasthan",
    },
    {
        nepali: "सुनौलोमकालु टोल विकास  संस्था",
        english: "sunaulomakalu tol bikas sasthan",
        value: "sunaulomakalu_tol_bikas_sasthan",
    },
    {
        nepali: "गौशाला  टोल विकास  संस्था",
        english: "gausala tol bikas sasthan",
        value: "gausala_tol_bikas_sasthan",
    },
    {
        nepali: "सगरमाथा  टोल विकास  संस्था",
        english: "sagarmatha tol bikas sasthan",
        value: "sagarmatha_tol_bikas_sasthan",
    },
    {
        nepali: "खोक्सी  टोल विकास  संस्था",
        english: "khokse tol bikas sasthan",
        value: "khokse_tol_bikas_sasthan",
    },
    {
        nepali: "खोक्सी  टोल विकास  संस्था २",
        english: "khose tol bikas sasthan2",
        value: "khose_tol_bikas_sasthan2",
    },
    {
        nepali: "जागृति  टोल विकास  संस्था",
        english: "jagrit tol bikas sasthan",
        value: "jagrit_tol_bikas_sasthan",
    },
    {
        nepali: "पशिचम फिमरा  टोल विकास  संस्था",
        english: "pachim fimara tol bikas sasthan",
        value: "pachim_fimara_tol_bikas_sasthan",
    },
    {
        nepali: "भीमचौरी  टोल",
        english: "bhimchouri tol",
        value: "bhimchouri_tol",
    },
    { nepali: "सकिम्मे चोक ,", english: "sakimme tol", value: "sakimme_tol" },
    { nepali: "हसिना टोल", english: "hasina tol", value: "hasina_tol" },
    { nepali: "नमुना टोल", english: "namuna tol", value: "namuna_tol" },
    { nepali: "गुरुङ टोल", english: "gurung tol", value: "gurung_tol" },
    {
        nepali: "लाटिझोडा  टोल विकास  संस्था टापु",
        english: "laatighoda tol bikas sasthan taapu",
        value: "laatighoda_tol_bikas_sasthan_taapu",
    },
    { nepali: "सजिलाल टोल", english: "sajilaal tol", value: "sajilaal_tol" },
    {
        nepali: "सुन्दर  जानसेवा टोल",
        english: "sundar_jaansewa_tol",
        value: "sundar_jaansewa_tol",
    },
    {
        nepali: "पुर्ब फिमरा टोल",
        english: "purb_fimaaraa_tol",
        value: "purb_fimaaraa_tol",
    },
    {
        nepali: "संगम टोल",
        english: "sangam1_tol",
        value: "sangam1_tol",
    },
    {
        nepali: "शिवालय टोल",
        english: "shiwalaya_tol",
        value: "shiwalaya_tol",
    },
    {
        nepali: "सिजर्ना टोल",
        english: "sirjana_tol",
        value: "sirjana_tol",
    },
    { nepali: "प्रगति टोल", english: "pragati tol", value: "pragati_tol" },
    {
        nepali: "सूर्योदय टोल",
        english: "suryadaya tol",
        value: "suryadaya_tol",
    },
    { nepali: "ज्योति  टोल", english: "jyoti tol", value: "jyoti_tol" },
    { nepali: "दोकाने टोल", english: "dokane tol", value: "dokane_tol" },
    { nepali: "डीपु टोल", english: "dipu tol ", value: "dipu_tol" },
    { nepali: "हाम्रो  टोल", english: "hamro tol ", value: "hamro_tol" },
    {
        nepali: "चन्द्र सुर्य टोल",
        english: "chandra surya tol ",
        value: "chandra_surya_tol",
    },
    {
        nepali: "गोदवारी टोल",
        english: "godayari tol",
        value: "godayari_tol",
    },
    { nepali: "गुम्बा टोल", english: "gumba tol ", value: "gumba_tol" },
    { nepali: "सिशौबारी टोल", english: " sisbari tol", value: "sisbari_tol" },
    {
        nepali: "स्कुल डाँडा टोल",
        english: "skul dada tol ",
        value: "skul_dada_tol",
    },
    { nepali: "कुमार टोल", english: " kumar tol", value: "kumar_tol" },
    {
        nepali: "दुर्गा मन्दिर टोल",
        english: " durga mandir tol",
        value: "durga_mandir_tol",
    },
    {
        nepali: " चौतारा सुकुना टोल",
        english: "chhatara sukunaa tol ",
        value: "chhatara_sukunaa_tol",
    },
    { nepali: "सितापुरे टोल", english: "sitapure tol ", value: "sitapure_tol" },
    {
        nepali: "पुष्पाञ्जली टोल",
        english: " puspaanjali tol",
        value: "puspaanjali_tol",
    },
    { nepali: "जागृति टोल", english: "jagirti tol", value: "jagirti_tol" },
    {
        nepali: "चन्द्र सुर्य टोल बिकास समिति",
        english: "chardra surya tol",
        value: "chardra_surya_tol",
    },
    {
        nepali: "गोठगाउँ पु. वि.वि",
        english: "godagau tol",
        value: "godagau_tol",
    },
    {
        nepali: "सृजना  टोल बिकास समिति",
        english: "sirjan tol",
        value: "sirjan_tol",
    },
    {
        nepali: "७५ विघे  टोल बिकास समिति",
        english: "75 biga tol",
        value: "75_biga_tol",
    },
    {
        nepali: "बेलागछी टोलविकास समिति",
        english: "belgachhi tol ",
        value: "belgachhi_tol",
    },
    {
        nepali: "गणेशपुर टोल विकास समिति",
        english: "ganesh tol ",
        value: "ganesh_tol",
    },
    {
        nepali: "गछिया  टोल बिकास समिति",
        english: "gachiya tol ",
        value: "gachiya_tol",
    },

    {
        nepali: "पाथिभरा  टोल बिकास समिति",
        english: "pathivara tol ",
        value: "pathivara_tol",
    },
    {
        nepali: "सुन्दर डाडागाउ  टोल बिकास समिति",
        english: "sundar dada gau tol ",
        value: "sundar_dada_gau_tol",
    },
    { nepali: "सलकपुर टोल", english: "salakpur tol", value: "salakpur_tol" },
    { nepali: "भुल्के टोल", english: "bhulke tol", value: "bhulke_tol" },
    {
        nepali: "पाथिभारा टोल",
        english: "paathivara tol 8",
        value: "paathivara_tol_8",
    },
    {
        nepali: "न्यौपाने टोल",
        english: "neupane tol",
        value: "mnehaneupane_tolra",
    },
    {
        nepali: "देबी बहादुर टोल",
        english: "devi bahadur tol ",
        value: "devi_bahadur_tol",
    },
    {
        nepali: "पोलाफयाक्टि टोल",
        english: "polafayakti tol",
        value: "polafayakti_tol",
    },
    { nepali: "ढकाल टोल", english: "dhakal tol", value: "dhakal_tol" },
    { nepali: "नागदेबी टोल", english: "nagdebi tol", value: "nagdebi_tol" },
    { nepali: "लाहुरे टोल", english: "laahure tol", value: "laahure_tol" },
    {
        nepali: "मध्याली टोल",
        english: "madhyali tol",
        value: "madhyali_tol",
    },
    {
        nepali: "चन्द्रनगर टोल",
        english: "chandrnagar tol",
        value: "chandrnagar_tol",
    },
    {
        nepali: "तालपोखरी टोल",
        english: "taalpokhari tol",
        value: "taalpokhari tol",
    },
    { nepali: "चिरम टोल", english: "chiran tol", value: "chiran_tol" },
    { nepali: "नमस्ते टोल", english: "namaste tol 8", value: "namaste_tol_8" },
    { nepali: "सुब्बा टोल", english: "shuba tol 8", value: "shuba_tol_8" },
    {
        nepali: "खानेपानी टोल",
        english: "khanepane tol 8",
        value: "khanepane_tol8",
    },
    { nepali: "पौडेल टोल", english: "poudel tol 8", value: "poudel_tol_8" },
    {
        nepali: "बिस्वबिधलय टोल",
        english: "university tol",
        value: "university_tol",
    },
    { nepali: "भ्रकुटि टोल ", english: "bhirkuti tol", value: "bhirkuti_tol" },
    {
        nepali: "पाथिभारा राज टोल",
        english: "paathivara raaj tol",
        value: "paathivara_raaj_tol",
    },
    { nepali: "चिरम टोल", english: "chiram tol ", value: "chiram_tol" },
    { nepali: "प्रकृती टोल ", english: "prakriti tol", value: "prakriti_tol" },
    { nepali: "मुसलिम टोल", english: "muslim tol", value: "muslim_tol" },
    { nepali: "बगाली टोल", english: "bangaali tol", value: "bangaali_tol" },
    { nepali: "मुसहर टोल", english: "musahar tol", value: "musahar_tol" },
    { nepali: "आदर्श चोक", english: "aadarsa tol", value: "aadarsa_tol" },
    {
        nepali: "गोबिन्द मार्ग",
        english: "gobinda marga",
        value: "gobinda_marga",
    },
    { nepali: "बुधबारे टोल", english: "budabaare tol", value: "budabaare_tol" },
    { nepali: "आइतबारे टोल", english: "aaitabar tol", value: "aaitabar_tol" },
    { nepali: "शान्ति टोल", english: "santi tol", value: "santi_tol" },
    { nepali: "सिर्जना टोल", english: "sirjana tol", value: "sirjana_tol" },
    { nepali: "मिलिजुली टोल", english: "milijuli tol", value: "milijuli_tol" },
    {
        nepali: "सन्यनारायण टोल",
        english: "satyanarayan tol",
        value: "satyanarayan_tol",
    },
    { nepali: "चित्रे टोल", english: "chitra tol", value: "chitra_tol" },
    { nepali: "बगदाद टोल", english: "bagdaad tol", value: "bagdaad_tol" },
    { nepali: "नागदेबी टोल", english: "nagdebi tol", value: "nagdebi_tol" },
    {
        nepali: "गरुंड टोल",
        english: "garud tol",
        value: "garud_tol",
    },
    {
        nepali: "ज्योति टोल  मार्ग",
        english: "jyoti tol",
        value: "jyoti_tol",
    },
    {
        nepali: "सैनिक मार्ग",
        english: "sainika marga",
        value: "sainika_marga",
    },
    {
        nepali: "मुनाल मार्ग",
        english: "munal marga",
        value: "munal_marga",
    },
    {
        nepali: "कालिमन्दिर मार्ग",
        english: "kaalimandir marg",
        value: "kaalimandir_marg",
    },
    { nepali: "जैनगर टोल", english: "jainagar tol", value: "jainagar_tol" },
    { nepali: "बिराटचोक बजार", english: "birat chok", value: "birat_chok" },
    {
        nepali: "दिपेन्द्र मार्ग",
        english: "dipendra marga",
        value: "dipendra_marga",
    },
    {
        nepali: "विराटचौक उत्तर  सनराईज मार्ग",
        english: "biratchowkuttar",
        value: "biratchowkuttar",
    },
    { nepali: "शुभम मार्ग", english: "shubham ", value: "shubham" },
    { nepali: "काजी  मार्ग", english: "kaajimarg", value: "kaajimarg" },
    {
        nepali: "हलेसी मार्ग",
        english: "halesi",
        value: "halesi",
    },
    { nepali: "दराईजिङ मार्ग ", english: "darising", value: "darising" },
    { nepali: "हिमाल मार्ग", english: "himal", value: "himal" },
    { nepali: "नरायण मार्ग", english: "narayan", value: "narayan" },
    {
        nepali: "प्रगति मार्ग",
        english: "pragati maarg",
        value: "pragati_maarg",
    },
    {
        nepali: "शान्ति मार्ग",
        english: "shaanti maarg",
        value: "shaanti_maarg",
    },
    {
        nepali: "जागृति मार्ग",
        english: "jaagriti maarg",
        value: "jaagriti_maarg",
    },
    { nepali: "शिद्वाथ  मार्ग", english: "shidaartha", value: "shidaartha" },
    { nepali: "बुद्व मार्ग", english: "buddha", value: "buddha" },
    {
        nepali: "त्रिवेणी मार्ग",
        english: "gaurishankar",
        value: "gaurishankar",
    },
    { nepali: "गौरीशंकर मार्ग", english: "triveni", value: "triveni" },
    { nepali: "भृकुटी मार्ग", english: "bhrikuti", value: "bhrikuti" },
    {
        nepali: "त्रिवेणी कंचनजंघा मार्ग",
        english: "kanchanmarg",
        value: "kanchanmarg",
    },
    {
        nepali: "त्रिवेणी पुर्व मितेरी मार्ग",
        english: "option 17",
        value: "option_17",
    },
    {
        nepali: "जनता टोल मार्ग",
        english: "option 18",
        value: "option_18",
    },
    { nepali: "हिमालय मार्ग", english: "option 19", value: "option_19" },

    {
        nepali: "गोपाल भण्डारी मार्ग",
        english: "option 20",
        value: "option_20",
    },
    {
        nepali: "न्यु मार्ग",
        english: "option 21",
        value: "option_21",
    },
    { nepali: "सात घरे मार्ग", english: "option 22", value: "option_22" },
    { nepali: "रुपाटार मार्ग", english: "option 23", value: "option_23" },
    { nepali: "लोक बहादुर मार्ग", english: "option 24", value: "option_24" },
    { nepali: "भण्डारी मार्ग", english: "option 25", value: "option_25" },
    { nepali: "गुरुजी टोल", english: "option 26", value: "option_26" },
    {
        nepali: "हरैचा मोड त्रिवेणी चोक",
        english: "option 27",
        value: "option_27",
    },
    { nepali: "गितांजलि मार्ग", english: "option 28", value: "option_28" },
    {
        nepali: "उद्दोग वाणिज्य संघ मार्ग",
        english: "option 29",
        value: "option_29",
    },
    { nepali: "प्रदिप मार्ग", english: "option 30", value: "option_30" },
    { nepali: "पानी टंकी  मार्ग", english: "option 31", value: "option_31" },
    { nepali: "तिन घरे मार्ग", english: "option 32", value: "option_32" },
    { nepali: "भोजपुरे मार्ग", english: "option 33", value: "option_33" },
    { nepali: "टिकाराम मार्ग", english: "option 34", value: "option_34" },
    { nepali: "भट्टराई मार्ग", english: "option 35", value: "option_35" },
    { nepali: "मुनाल मार्ग", english: "option 36", value: "option_36" },
    { nepali: "मुनाल झोडा", english: "option 37", value: "option_37" },
    { nepali: "छ थरे  मार्ग", english: "option 38", value: "option_38" },
    { nepali: "मिस्रित मार्ग", english: "option 39", value: "option_39" },
    { nepali: "शंकर पश्चिम मार्ग", english: "option 40", value: "option_40" },
    {
        nepali: "सट्टभर्ना उत्तर दक्षिण मार्ग",
        english: "option 41",
        value: "option_41",
    },
    {
        nepali: "एकता टोल बाटो नं, १,२,३,४,५,६,७,८",
        english: "option 42",
        value: "option_42",
    },
    { nepali: "लाङघारी मार्ग", english: "option 43", value: "option_43" },
    { nepali: "मितेरी मार्ग", english: "option 44", value: "option_44" },
    {
        nepali: "वरपिपल टोल पिपल चोक मार्ग",
        english: "option 45",
        value: "option_45",
    },
    { nepali: "सुकुना मार्ग", english: "option 46", value: "option_46" },
    { nepali: "चारकुने मार्ग", english: "option 47", value: "option_47" },
    { nepali: "स्वागत मार्ग", english: "option 48", value: "option_48" },
    { nepali: "यात्री मार्ग", english: "option 49", value: "option_49" },
    {
        nepali: "लक्ष्मी नारायण मार्ग",
        english: "option 50",
        value: "option_50",
    },
    {
        nepali: "कन्काई मार्ग खोर्साने",
        english: "option 51",
        value: "option_51",
    },
    { nepali: "भानु माग उत्तर", english: "option 52", value: "option_52" },
    { nepali: "सयपत्री मार्ग", english: "option 53", value: "option_53" },
    { nepali: "सेवारो मार्ग", english: "option 54", value: "option_54" },
    { nepali: "लालिगुरास मार्ग", english: "option 55", value: "option_55" },
    { nepali: "शितल मार्ग", english: "option 56", value: "option_56" },
    {
        nepali: "वनअफिस बागझोडा मार्ग",
        english: "option 57",
        value: "option_57",
    },
    { nepali: "राया टोल मार्ग", english: "option 58", value: "option_58" },
    { nepali: "न्यु रोड मार्ग", english: "option 59", value: "option_59" },
    { nepali: "अनु मसला मिल मार्ग", english: "option 60", value: "option_60" },
    { nepali: "जेष्ठ नागरिक मार्ग", english: "option 61", value: "option_61" },
    { nepali: "हाम्रो स्टोर मार्ग", english: "option 62", value: "option_62" },
    {
        nepali: "सिद्वार्थ बोर्डिंग मार्ग",
        english: "option 63",
        value: "option_63",
    },
    { nepali: "सिस्ती किरात मार्ग", english: "option 64", value: "option_64" },
    { nepali: "शिवालय मन्दिर मार्ग", english: "option 65", value: "option_65" },
    { nepali: "नमुना मार्ग", english: "option 66", value: "option_66" },
    { nepali: "डि आर मार्ग", english: "option 67", value: "option_67" },
    {
        nepali: "न्यौपाने चोक हुदै बाघझोडा मार्ग",
        english: "option 68",
        value: "option_68",
    },
    { nepali: "नटुवा डाँडा मार्ग", english: "option 69", value: "option_69" },
    {
        nepali: "बासुकी मार्ग गहिरी टोल",
        english: "option 70",
        value: "option_70",
    },
    { nepali: "विष्णुलाल मार्ग", english: "option 71", value: "option_71" },
    { nepali: "सुन्निमा मार्ग", english: "option 72", value: "option_72" },
    {
        nepali: "महेन्द्र मार्ग रुपाटार",
        english: "option 73",
        value: "option_73",
    },
    {
        nepali: "शान्ति मार्ग बाघझोडा",
        english: "option 74",
        value: "option_74",
    },
    {
        nepali: "माथिल्लो कर्जुना",
        english: "maathilo kajurna",
        value: "maathilo_kajurna",
    },
    {
        nepali: "तल्लो  कर्जुना",
        english: "talo kajurna",
        value: "talo_kajurna",
    },
    { nepali: "ग्रमथान", english: "gramthan", value: "gramthan" },
    { nepali: "बेलेपुर", english: "belepur", value: "belepur" },
    {
        nepali: "सगरमाथा टोल",
        english: "sagarmatha tol",
        value: "sagarmatha_tol",
    },
    {
        nepali: "पुरानो बेलेपुर टोल",
        english: "purano bele tol",
        value: "purano_bele_tol",
    },
    { nepali: "तीनपैनी टोल", english: "tinpaini tol", value: "tinpaini_tol" },
    {
        nepali: "भुटाइ र धाती टोल",
        english: "bhutai ra dhati tol",
        value: "bhutai_ra_dhati_tol",
    },
    {
        nepali: "तिनमोहडी टोल",
        english: "tinmohadi tol",
        value: "tinmohadi_tol",
    },
    {
        nepali: "शुक्रबारे टोल",
        english: "sukharbare tol",
        value: "sukharbare_tol",
    },
    {
        nepali: "लालिगुरास तथा पत्थरघट्ट",
        english: "laliguras tol",
        value: "laliguras_tol",
    },
    {
        nepali: "गोविन्दपुर टोल",
        english: "gobindapur tol ",
        value: "gobindapur_tol",
    },
    {
        nepali: "शिब मन्दिर टोल",
        english: "shiva mandir tol",
        value: "shiva_mandir_tol",
    },
    { nepali: "शान्ति टोल", english: " santi tol", value: "santi_tol" },
    {
        nepali: "खोर्साने टोल विकास संस्था",
        english: "khorsane tol",
        value: "khorsane_tol",
    },
    {
        nepali: "क्याम्पस  टोल विकास संस्था",
        english: "campus tol",
        value: "campus_tol",
    },
    {
        nepali: "सिद्धश्वर  टोल विकास संस्था",
        english: "sidrasor tol",
        value: "sidrasor_tol",
    },
    {
        nepali: "संगम   टोल विकास संस्था",
        english: "sangam tol",
        value: "sangam_tol",
    },
    {
        nepali: "प्रणाम  टोल विकास संस्था",
        english: "pranam tol",
        value: "pranam_tol",
    },
    { nepali: "अन्य", english: "Others", value: "others" },
];

export const toleWardOne = [
    {
        nepali: "हरैचा बजार पश्चिम (हस्पिटल रोड)",
        english: "dharapani",
        value: "dharapani",
    },
    {
        nepali: "हरैचा बजार पश्चिम (हुलाकि मार्ग)",
        english: "dhanpaal",
        value: "dhanpaal",
    },
    {
        nepali: "हरैचा बजार पश्चिम (हाटखोला मार्ग)",
        english: "hatkhola_marg",
        value: "hatkhola_marg",
    },
    {
        nepali: "हरैचा बजार पश्चिम (ईलाका प्रहरी सडक )",
        english: "ilaka_police_road",
        value: "ilaka_police_road",
    },
    {
        nepali: "हरैचा बजार पुर्वटोल",
        english: "haraicha_purwa",
        value: "haraicha_purwa",
    },
    {
        nepali: "हरैचा बजार",
        english: "haraicha_bazaar",
        value: "haraicha_bazaar",
    },
    {
        nepali: "तिम्सिना डाडाटोल",
        english: "timsina_dadatole",
        value: "timsina_dadatole",
    },
    {
        nepali: "संगीत चोक",
        english: "sangit_chowk",
        value: "sangit_chowk",
    },
    {
        nepali: "जनमैत्री मार्ग",
        english: "janamaitri_marg",
        value: "janamaitri_marg",
    },
    {
        nepali: "लक्ष्मीपुर टोल",
        english: "laxmipur",
        value: "laxmipur",
    },
    {
        nepali: "क्याम्पा टोल",
        english: "campa",
        value: "campa",
    },
    {
        nepali: "खोरिया टोल",
        english: "khoriya",
        value: "khoriya",
    },
    {
        nepali: "पशुपति टोल",
        english: "pashupati",
        value: "pashupati",
    },
    {
        nepali: "कुमार गाउँ स्कुल चौक",
        english: "kumar_gaun",
        value: "kumar_gaun",
    },
    {
        nepali: "सिमल डाडा टोल",
        english: "simal_danda",
        value: "simal_danda",
    },
    {
        nepali: "कार्की टोल",
        english: "karki",
        value: "karki",
    },
    {
        nepali: "सुक्रबारे",
        english: "sukrabare",
        value: "sukrabare",
    },
    {
        nepali: "माथिल्लो सितुमारी टोल",
        english: "situmari_tol",
        value: "situmari_tol",
    },
    {
        nepali: "तल्लो  सितुमारी टोल",
        english: "tallo_situmari",
        value: "tallo_situmari",
    },
    {
        nepali: "सितुमारी धामी बस्नेत टोल",
        english: "situmari_dhami",
        value: "situmari_dhami",
    },
    {
        nepali: "बानडाडा टोल",
        english: "bandanda",
        value: "bandanda",
    },
    {
        nepali: "इटाभट्टा टोल",
        english: "itabhaatta",
        value: "itabhaatta",
    },
    {
        nepali: "डागी टोल ( मदन आश्रित मार्ग )",
        english: "dangi_tol",
        value: "dangi_tol",
    },
    {
        nepali: "डागी टोल (मदन आश्रित मार्ग देखि लक्षिण लक्ष्मीपुर सम्म)",
        english: "dangi_tol_laxmipur",
        value: "dangi_tol_laxmipur",
    },
    {
        nepali: "लक्ष्मीपुर बेलेपुर सडक",
        english: "belepur",
        value: "belepur",
    },
    {
        nepali: "प्रतिटोल",
        english: "prati_tol",
        value: "prati_tol",
    },
    {
        nepali: "मास्टर टोल",
        english: "master_tl",
        value: "master_tl",
    },
    {
        nepali: "हरैचा टोल पचाम",
        english: "haraincha_pachan",
        value: "haraincha_pachan",
    },
    {
        nepali: "धाबीटोल मार्ग",
        english: "dhabitol",
        value: "dhabitol",
    },
    {
        nepali: "टनकपुर टोल",
        english: "tanakpur",
        value: "tanakpur",
    },
    {
        nepali: "मुस्लिम टोल",
        english: "muslim_tol_1",
        value: "muslim_tol_1",
    },
    {
        nepali: "पचाम नयाँ बेलपुर टोल",
        english: "pacham_belpur",
        value: "pacham_belpur",
    },
    {
        nepali: "पचाम स्कुल टोल",
        english: "pacham_school",
        value: "pacham_school",
    },
    {
        nepali: "जलेश्वर टोल",
        english: "jaleshwor_tol",
        value: "jaleshwor_tol",
    },
    {
        nepali: "पचाम",
        english: "pacham",
        value: "pacham",
    },
    {
        nepali: "तिम्सिना टोल खदम",
        english: "timsina_khadam",
        value: "timsina_khadam",
    },
    {
        nepali: "ढकाल टोल",
        english: "dhakal_tol_1",
        value: "dhakal_tol_1",
    },
    {
        nepali: "खदम",
        english: "khadam",
        value: "khadam",
    },
    {
        nepali: "कार्की टोल खदम उपकार चोक खदम",
        english: "karki_tol",
        value: "karki_tol",
    },
    {
        nepali: "कार्की टोल खदम",
        english: "karki_tol_khadam",
        value: "karki_tol_khadam",
    },
    {
        nepali: "हवल्दार टोल खदम",
        english: "hawaldar_tol",
        value: "hawaldar_tol",
    },
    {
        nepali: "सरस्वति टोल खदम",
        english: "sarswati_tol_khadam",
        value: "sarswati_tol_khadam",
    },
    {
        nepali: "पचान थान टोल",
        english: "pacham_than_tol",
        value: "pacham_than_tol",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const toleWardTwo = [
    {
        nepali: "ऐलानपुर",
        english: "alaanpur_tol",
        value: "alaanpur_tol",
    },
    {
        nepali: "मझुवा",
        english: "mujhuwa_tol",
        value: "mujhuwa_tol",
    },
    {
        nepali: "भगत टोल",
        english: "bhagat_tol",
        value: "bhagat_tol",
    },
    {
        nepali: "बेलडाँगी टोल",
        english: "beladagi_tol",
        value: "beladagi_tol",
    },
    {
        nepali: "मालती टोल",
        english: "maalti_tol",
        value: "maalti_tol",
    },
    {
        nepali: "लालबस्ती टोल",
        english: "laalbasti_tol",
        value: "laalbasti_tol",
    },
    {
        nepali: "खोरिया टोल",
        english: "koriya_tol",
        value: "koriya_tol",
    },
    {
        nepali: "उफैलिया टोल",
        english: "ufailiya_tol",
        value: "ufailiya_tol",
    },
    {
        nepali: "उफैलिया झाँगर टोल",
        english: "ufailiya_jhagar_tol",
        value: "ufailiya_jhagar_tol",
    },
    {
        nepali: "मृगौलिया बजार टोल",
        english: "mirgauliya_bajar_tol",
        value: "mirgauliya_bajar_tol",
    },
    {
        nepali: "लापटोली",
        english: "laapatoli",
        value: "laapatoli",
    },
    {
        nepali: "हिमाल चोक",
        english: "himal_chok",
        value: "himal_chok",
    },
    {
        nepali: "कराईवाना टोल",
        english: "karaiwana_tol",
        value: "karaiwana_tol",
    },
    {
        nepali: "तल्लो कराईवाना",
        english: "talo_karaiwana",
        value: "talo_karaiwana",
    },
    {
        nepali: "जोगियारे टोल",
        english: "gogiyare_tol",
        value: "gogiyare_tol",
    },
    {
        nepali: "खोटाङगे टोल",
        english: "khotang_tol",
        value: "khotang_tol",
    },
    {
        nepali: "बेलडागी स्कुल टोल",
        english: "beldaagi_school_tol_1",
        value: "beldaagi_school_tol_1",
    },
    {
        nepali: "जोगियारे पुर्ब टोल",
        english: "jogiyare_purb_toll",
        value: "jogiyare_purb_toll",
    },
    {
        nepali: "फुलबारी टोल",
        english: "fulbaari_tol_1",
        value: "fulbaari_tol_1",
    },
    {
        nepali: "सुब्बा टोल",
        english: "fulbaari_tol",
        value: "fulbaari_tol",
    },
    {
        nepali: "गोलापरासी टोल",
        english: "golaaparaasi_toll",
        value: "golaaparaasi_toll",
    },
    {
        nepali: "बिशाल मार्ग",
        english: "bisal_marga",
        value: "bisal_marga",
    },
    {
        nepali: "पत्थर घट्ट टोल",
        english: "pathar_ghata_tol",
        value: "pathar_ghata_tol",
    },
    {
        nepali: "पत्थर घट्ट टावर टोल",
        english: "pathar_ghata_tawor_tol",
        value: "pathar_ghata_tawor_tol",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const toleWardThree = [
    {
        nepali: "गछिया बजार",
        english: "gachhiya_bajaar",
        value: "gachhiya_bajaar",
    },
    {
        nepali: "शान्ति टोल",
        english: "santhi_tol",
        value: "santhi_tol",
    },
    {
        nepali: "लक्ष्मी नारायण टोल",
        english: "laxmi_naraayan_tol",
        value: "laxmi_naraayan_tol",
    },
    {
        nepali: "नमुना टोल",
        english: "namunaa_tol",
        value: "namunaa_tol",
    },
    {
        nepali: "वेलगाछी टोल",
        english: "belgaachhi_tol",
        value: "belgaachhi_tol",
    },
    {
        nepali: "त्रिजुगा टोल",
        english: "trijugaa_tol",
        value: "trijugaa_tol",
    },
    {
        nepali: "आम्झोकी टोल",
        english: "aaamjoki_tol",
        value: "aaamjoki_tol",
    },
    {
        nepali: "मालती टोल",
        english: "maalati_tol",
        value: "maalati_tol",
    },
    {
        nepali: "वाइचोक टोल",
        english: "waichhok_tol",
        value: "waichhok_tol",
    },
    {
        nepali: "लिम्बु डाडा टोल",
        english: "limbu_dhada_tol",
        value: "limbu_dhada_tol",
    },
    {
        nepali: "लाल वस्ती टोल",
        english: "lal_basti_tol",
        value: "lal_basti_tol",
    },
    {
        nepali: "घेरावानी टोल",
        english: "geraawaani_tol",
        value: "geraawaani_tol",
    },
    {
        nepali: "शेषनारायण टोल",
        english: "seshnaaraayan_tol",
        value: "seshnaaraayan_tol",
    },
    {
        nepali: "मनकामना टोल",
        english: "manakaamana_tol",
        value: "manakaamana_tol",
    },
    {
        nepali: "रेडक्रस टोल",
        english: "redcross_tol",
        value: "redcross_tol",
    },
    {
        nepali: "नयाँ टोल",
        english: "nayaa_tol",
        value: "nayaa_tol",
    },
    {
        nepali: "शान्तासिटौला घर उतर डाडा टोल",
        english: "santashitaula_ghar_utar_dhada_tol",
        value: "santashitaula_ghar_utar_dhada_tol",
    },
    {
        nepali: "लोचनी चौधरी टोल",
        english: "lochani_chhaudari_tol",
        value: "lochani_chhaudari_tol",
    },
    {
        nepali: "चिचरबना खाप टोल",
        english: "chichrbana_khaap_tol",
        value: "chichrbana_khaap_tol",
    },
    {
        nepali: "पशुपति टोल",
        english: "pasupati_tol",
        value: "pasupati_tol",
    },
    {
        nepali: "आइतबार टोल",
        english: "aaitabare_tol",
        value: "aaitabare_tol",
    },
    {
        nepali: "इराक टोल",
        english: "irak_tol",
        value: "irak_tol",
    },
    {
        nepali: "बीचबाध त्रिजुगा",
        english: "bichbaada_trijugaa",
        value: "bichbaada_trijugaa",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const toleWardFour = [
    {
        nepali: "लालिगुरास टोल",
        english: "laliguras_tol",
        value: "laliguras_tol",
    },
    {
        nepali: "अनुकुलनगर टोल",
        english: "anukulanagar_tol",
        value: "anukulanagar_tol",
    },
    {
        nepali: "बुद्ध गंगा टोल",
        english: "budha_ganga_tol",
        value: "budha_ganga_tol",
    },
    {
        nepali: "बासबारी टोल",
        english: "basbari_tol",
        value: "basbari_tol",
    },
    {
        nepali: "चरिगुवा टोल",
        english: "chariguwa_tol",
        value: "chariguwa_tol",
    },
    {
        nepali: "मातृभुमि टोल",
        english: "maatribhumi_tol",
        value: "maatribhumi_tol",
    },
    {
        nepali: "गौरी गाउँ टोल",
        english: "gouri_gaau_tol",
        value: "gouri_gaau_tol",
    },
    {
        nepali: "बडहरा खाप टोल",
        english: "badahara_khap_tol",
        value: "badahara_khap_tol",
    },
    {
        nepali: "बुद्ध नगर टोल",
        english: "budha_nagar_tol",
        value: "budha_nagar_tol",
    },
    {
        nepali: "नयाँ टोलि  टोल",
        english: "naya_toli_tol",
        value: "naya_toli_tol",
    },
    {
        nepali: "हवेली टोल",
        english: "haweli_tol",
        value: "haweli_tol",
    },
    {
        nepali: "सिदार्थ टोल",
        english: "sidartha_tol",
        value: "sidartha_tol",
    },
    {
        nepali: "चरिगुवा टोल",
        english: "chariguwa_tol_1",
        value: "chariguwa_tol_1",
    },
    {
        nepali: "बलियो टोल",
        english: "baliyo_tol",
        value: "baliyo_tol",
    },
    {
        nepali: "पानि टयाङकि टोल",
        english: "pani_tanki_tol",
        value: "pani_tanki_tol",
    },
    {
        nepali: "चेतनशील टोल",
        english: "chetansil_tol",
        value: "chetansil_tol",
    },
    {
        nepali: "मंगलदीप टोल",
        english: "mangaldip_tol",
        value: "mangaldip_tol",
    },
    {
        nepali: "उन्नति टोल",
        english: "unaanti_tol",
        value: "unaanti_tol",
    },
    {
        nepali: "बडहरा टोल",
        english: "badahara_tol",
        value: "badahara_tol",
    },
    {
        nepali: "शिवालय टोल",
        english: "siwalaya_tol",
        value: "siwalaya_tol",
    },
    {
        nepali: "भोलेश्वर टोल",
        english: "bholeswor_tol",
        value: "bholeswor_tol",
    },
    {
        nepali: "मुनाल मार्ग",
        english: "munal_tol",
        value: "munal_tol",
    },
    {
        nepali: "गैरी टोल",
        english: "gauri_tol",
        value: "gauri_tol",
    },
    {
        nepali: "तेलिया टोल",
        english: "teliya_tol",
        value: "teliya_tol",
    },
    {
        nepali: "सिमल डाडा  टोल",
        english: "simal_dadha_tol",
        value: "simal_dadha_tol",
    },
    {
        nepali: "त्रिबेणी टोल",
        english: "tribeni_tol",
        value: "tribeni_tol",
    },
    {
        nepali: "५ बिध्ये टोल",
        english: "pacha_bidya_tol",
        value: "pacha_bidya_tol",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const toleWardFive = [
    {
        nepali: "सुन्दर बलिया टोल विकास  संस्था",
        english: "sundar_baliya_tol_bikas_sasthan",
        value: "sundar_baliya_tol_bikas_sasthan",
    },
    {
        nepali: "अमर ज्योति टोल विकास  संस्था",
        english: "amar_joty_tol_bikas_sasthan",
        value: "amar_joty_tol_bikas_sasthan",
    },
    {
        nepali: "शान्ति टोल विकास  संस्था",
        english: "santi_tol_bikas_sasthan",
        value: "santi_tol_bikas_sasthan",
    },
    {
        nepali: "पाथीभरा  टोल विकास  संस्था",
        english: "paathivara_tol_bikas_sasthan",
        value: "paathivara_tol_bikas_sasthan",
    },
    {
        nepali: "मिलिजुली  टोल विकास  संस्था",
        english: "milijuli_tol_bikas_sasthan",
        value: "milijuli_tol_bikas_sasthan",
    },
    {
        nepali: "सिदार्थ  टोल विकास  संस्था",
        english: "sidartha_tol_bikas_sasthan",
        value: "sidartha_tol_bikas_sasthan",
    },
    {
        nepali: "फुलबारी  टोल विकास  संस्था",
        english: "fulbari_tol_bikas_sasthan",
        value: "fulbari_tol_bikas_sasthan",
    },
    {
        nepali: "सुनौलोमकालु टोल विकास  संस्था",
        english: "sunaulomakalu_tol_bikas_sasthan",
        value: "sunaulomakalu_tol_bikas_sasthan",
    },
    {
        nepali: "गौशाला  टोल विकास  संस्था",
        english: "gausala_tol_bikas_sasthan",
        value: "gausala_tol_bikas_sasthan",
    },
    {
        nepali: "सगरमाथा  टोल विकास  संस्था",
        english: "sagarmatha_tol_bikas_sasthan",
        value: "sagarmatha_tol_bikas_sasthan",
    },
    {
        nepali: "खोक्सी  टोल विकास  संस्था",
        english: "khokse_tol_bikas_sasthan",
        value: "khokse_tol_bikas_sasthan",
    },
    {
        nepali: "खोक्सी  टोल विकास  संस्था २",
        english: "khose_tol_bikas_sasthan2",
        value: "khose_tol_bikas_sasthan2",
    },
    {
        nepali: "अन्यजागृति  टोल विकास  संस्था",
        english: "jagrit_tol_bikas_sasthan",
        value: "jagrit_tol_bikas_sasthan",
    },
    {
        nepali: "पशिचम फिमरा  टोल विकास  संस्था",
        english: "pachim_fimara_tol_bikas_sasthan",
        value: "pachim_fimara_tol_bikas_sasthan",
    },
    {
        nepali: "भीमचौरी  टोल",
        english: "bhimchouri_tol",
        value: "bhimchouri_tol",
    },
    {
        nepali: "सकिम्मे चोक",
        english: "sakimme_tol",
        value: "sakimme_tol",
    },
    {
        nepali: "हसिना टोल",
        english: "hasina_tol",
        value: "hasina_tol",
    },
    {
        nepali: "नमुना टोल",
        english: "namuna_tol",
        value: "namuna_tol",
    },
    {
        nepali: "गुरुङ टोल",
        english: "gurung_tol",
        value: "gurung_tol",
    },
    {
        nepali: "लाटिझोडा  टोल विकास  संस्था टापु",
        english: "laatighoda_tol_bikas_sasthan_taapu",
        value: "laatighoda_tol_bikas_sasthan_taapu",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const toleWardSix = [
    {
        nepali: "सजिलाल टोल",
        english: "sajilaal_tol",
        value: "sajilaal_tol",
    },
    {
        nepali: "सुन्दर जानसेवा टोल",
        english: "sundar_jaansewa_tol",
        value: "sundar_jaansewa_tol",
    },
    {
        nepali: "पुर्ब फिमरा टोल",
        english: "purb_fimaaraa_tol",
        value: "purb_fimaaraa_tol",
    },
    {
        nepali: "संगम टोल",
        english: "sangam1_tol",
        value: "sangam1_tol",
    },
    {
        nepali: "शिवालय टोल",
        english: "shiwalaya_tol",
        value: "shiwalaya_tol",
    },
    {
        nepali: "सिजर्ना टोल",
        english: "sirjana_tol",
        value: "sirjana_tol",
    },
    {
        nepali: "प्रगति टोल",
        english: "pragati_tol",
        value: "pragati_tol",
    },
    {
        nepali: "सूर्योदय टोल",
        english: "suryadaya_tol",
        value: "suryadaya_tol",
    },
    {
        nepali: "ज्योति टोल",
        english: "jyoti_tol",
        value: "jyoti_tol",
    },
    {
        nepali: "दोकाने टोल",
        english: "dokane_tol",
        value: "dokane_tol",
    },
    {
        nepali: "डीपु टोल",
        english: "dipu_tol",
        value: "dipu_tol",
    },
    {
        nepali: "हाम्रो टोल",
        english: "hamro_tol",
        value: "hamro_tol",
    },
    {
        nepali: "चन्द्र सुर्य टोल",
        english: "chandra_surya_tol",
        value: "chandra_surya_tol",
    },
    {
        nepali: "गोदवारी टोल",
        english: "godayari_tol",
        value: "godayari_tol",
    },
    {
        nepali: "गुम्बा टोल",
        english: "gumba_tol",
        value: "gumba_tol",
    },
    {
        nepali: "सिशौबारी टोल",
        english: "sisbari_tol",
        value: "sisbari_tol",
    },
    {
        nepali: "स्कुल डाँडा टोल",
        english: "skul_dada_tol",
        value: "skul_dada_tol",
    },
    {
        nepali: "कुमार टोल",
        english: "kumar_tol",
        value: "kumar_tol",
    },
    {
        nepali: "दुर्गा मन्दिर टोल",
        english: "durga_mandir_tol",
        value: "durga_mandir_tol",
    },
    {
        nepali: "चौतारा सुकुना टोल",
        english: "chhatara_sukunaa_tol",
        value: "chhatara_sukunaa_tol",
    },
    {
        nepali: "सितापुरे टोल",
        english: "sitapure_tol",
        value: "sitapure_tol",
    },
    {
        nepali: "पुष्पाञ्जली टोल",
        english: "puspaanjali_tol",
        value: "puspaanjali_tol",
    },
    {
        nepali: "जागृति टोल",
        english: "jagirti_tol",
        value: "jagirti_tol",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const toleWardSeven = [
    {
        nepali: "चन्द्र सुर्य टोल बिकास समिति",
        english: "chardra_surya_tol",
        value: "chardra_surya_tol",
    },
    {
        nepali: "गोठगाउँ पु. वि.वि",
        english: "godagau_tol",
        value: "godagau_tol",
    },
    {
        nepali: "सृजना टोल बिकास समिति",
        english: "sirjan_tol",
        value: "sirjan_tol",
    },
    {
        nepali: "७५ विघे टोल बिकास समिति",
        english: "75_biga_tol",
        value: "75_biga_tol",
    },
    {
        nepali: "बेलागछी टोलविकास समिति",
        english: "belgachhi_tol",
        value: "belgachhi_tol",
    },
    {
        nepali: "गणेशपुर टोल विकास समिति",
        english: "ganesh_tol",
        value: "ganesh_tol",
    },
    {
        nepali: "गछिया टोल बिकास समिति",
        english: "gachiya_tol",
        value: "gachiya_tol",
    },
    {
        nepali: "पाथिभरा टोल बिकास समिति",
        english: "pathivara_tol",
        value: "pathivara_tol",
    },
    {
        nepali: "सुन्दर डाडागाउ  टोल बिकास समिति",
        english: "sundar_dada_gau_tol",
        value: "sundar_dada_gau_tol",
    },
    {
        nepali: "ठडीया टोल विकास समिति",
        english: "thadiy_tol",
        value: "thadiy_tol",
    },
    {
        nepali: "कल्याण टोल विकास समिति",
        english: "kalyan_tol",
        value: "kalyan_tol",
    },
    {
        nepali: "मधा एकता टोल विकास समिति",
        english: "madha_tol",
        value: "madha_tol",
    },
    {
        nepali: "परिवर्तन टोल विकास समिति",
        english: "pariwartan_tol",
        value: "pariwartan_tol",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const toleWardEight = [
    {
        nepali: "सलकपुर टोल",
        english: "salakpur_tol",
        value: "salakpur_tol",
    },
    {
        nepali: "भुल्के टोल",
        english: "bhulke_tol",
        value: "bhulke_tol",
    },
    {
        nepali: "पाथिभारा टोल",
        english: "paathivara_tol_8",
        value: "paathivara_tol_8",
    },
    {
        nepali: "न्यौपाने टोल",
        english: "neupane_tol",
        value: "neupane_tol",
    },
    {
        nepali: "देबी बहादुर टोल",
        english: "devi_bahadur_tol",
        value: "devi_bahadur_tol",
    },
    {
        nepali: "पोलाफयाक्टि पुर्ब टोल",
        english: "polafayakti_purb_tol",
        value: "polafayakti_purb_tol",
    },
    {
        nepali: "पोलाफयाक्टि टोल",
        english: "polafayakti_tol",
        value: "polafayakti_tol",
    },
    {
        nepali: "ढकाल टोल",
        english: "dhakal_tol",
        value: "dhakal_tol",
    },
    {
        nepali: "नागदेबी टोल",
        english: "nagdebi_tol",
        value: "nagdebi_tol",
    },
    {
        nepali: "लाहुरे टोल",
        english: "laahure_tol",
        value: "laahure_tol",
    },
    {
        nepali: "मध्याली टोल",
        english: "madhyali_tol",
        value: "madhyali_tol",
    },
    {
        nepali: "चन्द्रनगर टोल",
        english: "chandrnagar_tol",
        value: "chandrnagar_tol",
    },
    {
        nepali: "तालपोखरी टोल",
        english: "taalpokhari_tol",
        value: "taalpokhari_tol",
    },
    {
        nepali: "चिरम टोल",
        english: "chiran_tol",
        value: "chiran_tol",
    },
    {
        nepali: "नमस्ते टोल",
        english: "namaste_tol_8",
        value: "namaste_tol_8",
    },
    {
        nepali: "सुब्बा टोल",
        english: "shuba_tol_8",
        value: "shuba_tol_8",
    },
    {
        nepali: "खानेपानी टोल",
        english: "khanepane_tol8",
        value: "khanepane_tol8",
    },
    {
        nepali: "पौडेल टोल",
        english: "poudel_tol_8",
        value: "poudel_tol_8",
    },
    {
        nepali: "बिस्वबिधलय टोल",
        english: "university_tol",
        value: "university_tol",
    },
    {
        nepali: "भ्रकुटि टोल",
        english: "bhirkuti_tol",
        value: "bhirkuti_tol",
    },
    {
        nepali: "पाथिभारा राज टोल",
        english: "paathivara_raaj_tol",
        value: "paathivara_raaj_tol",
    },
    {
        nepali: "चिरम टोल",
        english: "chiram_tol",
        value: "chiram_tol",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const toleWardNine = [
    {
        nepali: "प्रकृती टोल",
        english: "prakriti_tol",
        value: "prakriti_tol",
    },
    {
        nepali: "मुसलिम टोल",
        english: "muslim_tol",
        value: "muslim_tol",
    },
    {
        nepali: "बगाली टोल",
        english: "bangaali_tol",
        value: "bangaali_tol",
    },
    {
        nepali: "मुसहर टोल",
        english: "musahar_tol",
        value: "musahar_tol",
    },
    {
        nepali: "आदर्श चोक",
        english: "aadarsa_tol",
        value: "aadarsa_tol",
    },
    {
        nepali: "गोबिन्द मार्ग",
        english: "gobinda_marga",
        value: "gobinda_marga",
    },
    {
        nepali: "बुधबारे टोल",
        english: "budabaare_tol",
        value: "budabaare_tol",
    },
    {
        nepali: "आइतबारे टोल",
        english: "aaitabar_tol",
        value: "aaitabar_tol",
    },
    {
        nepali: "शान्ति टोल",
        english: "santi_tol",
        value: "santi_tol",
    },
    {
        nepali: "सिर्जना टोल",
        english: "sirjana_tol",
        value: "sirjana_tol",
    },
    {
        nepali: "मिलिजुली टोल",
        english: "milijuli_tol",
        value: "milijuli_tol",
    },
    {
        nepali: "सन्यनारायण टोल",
        english: "satyanarayan_tol",
        value: "satyanarayan_tol",
    },
    {
        nepali: "चित्रे टोल",
        english: "chitra_tol",
        value: "chitra_tol",
    },
    {
        nepali: "बगदाद टोल",
        english: "bagdaad_tol",
        value: "bagdaad_tol",
    },
    {
        nepali: "नागदेबी टोल",
        english: "nagdebi_tol",
        value: "nagdebi_tol",
    },
    {
        nepali: "गरुंड टोल",
        english: "garud_tol",
        value: "garud_tol",
    },
    {
        nepali: "ज्योति टोल मार्ग",
        english: "jyoti_tol",
        value: "jyoti_tol",
    },
    {
        nepali: "सैनिक मार्ग",
        english: "sainika_marga",
        value: "sainika_marga",
    },
    {
        nepali: "मुनाल मार्ग",
        english: "munal_marga",
        value: "munal_marga",
    },
    {
        nepali: "कालिमन्दिर मार्ग",
        english: "kaalimandir_marg",
        value: "kaalimandir_marg",
    },
    {
        nepali: "जैनगर टोल",
        english: "jainagar_tol",
        value: "jainagar_tol",
    },
    {
        nepali: "बिराटचोक बजार",
        english: "birat_chok",
        value: "birat_chok",
    },
    {
        nepali: "दिपेन्द्र मार्ग",
        english: "dipendra_marga",
        value: "dipendra_marga",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const toleWardTen = [
    {
        nepali: "विराटचौक उत्तर सनराईज मार्ग",
        english: "option_1",
        value: "option_1",
    },
    {
        nepali: "शुभम मार्ग",
        english: "option_2",
        value: "option_2",
    },
    {
        nepali: "काजी मार्ग",
        english: "option_3",
        value: "option_3",
    },
    {
        nepali: "हलेसी मार्ग",
        english: "option_4",
        value: "option_4",
    },
    {
        nepali: "दराईजिङ मार्ग",
        english: "option_5",
        value: "option_5",
    },
    {
        nepali: "हिमाल मार्ग",
        english: "option_6",
        value: "option_6",
    },
    {
        nepali: "नरायण मार्ग",
        english: "option_7",
        value: "option_7",
    },
    {
        nepali: "प्रगति मार्ग",
        english: "option_8",
        value: "option_8",
    },
    {
        nepali: "शान्ति मार्ग",
        english: "option_9",
        value: "option_9",
    },
    {
        nepali: "जागृति मार्ग",
        english: "option_10",
        value: "option_10",
    },
    {
        nepali: "शिद्वाथ मार्ग",
        english: "option_11",
        value: "option_11",
    },
    {
        nepali: "बुद्व मार्ग",
        english: "option_12",
        value: "option_12",
    },
    {
        nepali: "त्रिवेणी मार्ग",
        english: "option_13",
        value: "option_13",
    },
    {
        nepali: "गौरीशंकर मार्ग",
        english: "option_14",
        value: "option_14",
    },
    {
        nepali: "भृकुटी मार्ग",
        english: "option_15",
        value: "option_15",
    },
    {
        nepali: "त्रिवेणी कंचनजंघा मार्ग",
        english: "option_16",
        value: "option_16",
    },
    {
        nepali: "त्रिवेणी पुर्व मितेरी मार्ग",
        english: "option_17",
        value: "option_17",
    },
    {
        nepali: "जनता टोल मार्ग",
        english: "option_18",
        value: "option_18",
    },
    {
        nepali: "हिमालय मार्ग",
        english: "option_19",
        value: "option_19",
    },
    {
        nepali: "गोपाल भण्डारी मार्ग",
        english: "option_20",
        value: "option_20",
    },
    {
        nepali: "न्यु मार्ग",
        english: "option_21",
        value: "option_21",
    },
    {
        nepali: "सात घरे मार्ग",
        english: "option_22",
        value: "option_22",
    },
    {
        nepali: "रुपाटार मार्ग",
        english: "option_23",
        value: "option_23",
    },
    {
        nepali: "लोक बहादुर मार्ग",
        english: "option_24",
        value: "option_24",
    },
    {
        nepali: "भण्डारी मार्ग",
        english: "option_25",
        value: "option_25",
    },
    {
        nepali: "गुरुजी टोल",
        english: "option_26",
        value: "option_26",
    },
    {
        nepali: "हरैचा मोड त्रिवेणी चोक",
        english: "option_27",
        value: "option_27",
    },
    {
        nepali: "गितांजलि मार्ग",
        english: "option_28",
        value: "option_28",
    },
    {
        nepali: "उद्दोग वाणिज्य संघ मार्ग",
        english: "option_29",
        value: "option_29",
    },
    {
        nepali: "प्रदिप मार्ग",
        english: "option_30",
        value: "option_30",
    },
    {
        nepali: "पानी टंकी  मार्ग",
        english: "option_31",
        value: "option_31",
    },
    {
        nepali: "तिन घरे मार्ग",
        english: "option_32",
        value: "option_32",
    },
    {
        nepali: "भोजपुरे मार्ग",
        english: "option_33",
        value: "option_33",
    },
    {
        nepali: "टिकाराम मार्ग",
        english: "option_34",
        value: "option_34",
    },
    {
        nepali: "भट्टराई मार्ग",
        english: "option_35",
        value: "option_35",
    },
    {
        nepali: "मुनाल मार्ग",
        english: "option_36",
        value: "option_36",
    },
    {
        nepali: "मुनाल झोडा",
        english: "option_37",
        value: "option_37",
    },
    {
        nepali: "छ थरे मार्ग",
        english: "option_38",
        value: "option_38",
    },
    {
        nepali: "मिस्रित मार्ग",
        english: "option_39",
        value: "option_39",
    },
    {
        nepali: "शंकर पश्चिम मार्ग",
        english: "option_40",
        value: "option_40",
    },
    {
        nepali: "सट्टभर्ना उत्तर दक्षिण मार्ग",
        english: "option_41",
        value: "option_41",
    },
    {
        nepali: "एकता टोल बाटो नं, १,२,३,४,५,६,७,८",
        english: "option_42",
        value: "option_42",
    },
    {
        nepali: "लाङघारी मार्ग",
        english: "option_43",
        value: "option_43",
    },
    {
        nepali: "मितेरी मार्ग",
        english: "option_44",
        value: "option_44",
    },
    {
        nepali: "वरपिपल टोल पिपल चोक मार्ग",
        english: "option_45",
        value: "option_45",
    },
    {
        nepali: "सुकुना मार्ग",
        english: "option_46",
        value: "option_46",
    },
    {
        nepali: "चारकुने मार्ग",
        english: "option_47",
        value: "option_47",
    },
    {
        nepali: "स्वागत मार्ग",
        english: "option_48",
        value: "option_48",
    },
    {
        nepali: "यात्री मार्ग",
        english: "यात्री मार्ग",
        value: "यात्री मार्ग",
    },
    {
        nepali: "लक्ष्मी नारायण मार्ग",
        english: "option_50",
        value: "option_50",
    },
    {
        nepali: "कन्काई मार्ग खोर्साने",
        english: "option_51",
        value: "option_51",
    },
    {
        nepali: "भानु माग उत्तर",
        english: "option_52",
        value: "option_52",
    },
    {
        nepali: "सयपत्री मार्ग",
        english: "option_53",
        value: "option_53",
    },
    {
        nepali: "सेवारो मार्ग",
        english: "option_54",
        value: "option_54",
    },
    {
        nepali: "लालिगुरास मार्ग",
        english: "option_55",
        value: "option_55",
    },
    {
        nepali: "शितल मार्ग",
        english: "option_56",
        value: "option_56",
    },
    {
        nepali: "वनअफिस बागझोडा मार्ग",
        english: "option_57",
        value: "option_57",
    },
    {
        nepali: "राया टोल मार्ग",
        english: "option_58",
        value: "option_58",
    },
    {
        nepali: "न्यु रोड मार्ग",
        english: "option_59",
        value: "option_59",
    },
    {
        nepali: "अनु मसला मिल मार्ग",
        english: "option_60",
        value: "option_60",
    },
    {
        nepali: "जेष्ठ नागरिक मार्ग",
        english: "option_61",
        value: "option_61",
    },
    {
        nepali: "हाम्रो स्टोर मार्ग",
        english: "option_62",
        value: "option_62",
    },
    {
        nepali: "सिद्वार्थ बोर्डिंग मार्ग",
        english: "option_63",
        value: "option_63",
    },
    {
        nepali: "सिस्ती किरात मार्ग",
        english: "option_64",
        value: "option_64",
    },
    {
        nepali: "शिवालय मन्दिर मार्ग",
        english: "option_65",
        value: "option_65",
    },
    {
        nepali: "नमुना मार्ग",
        english: "option_66",
        value: "option_66",
    },
    {
        nepali: "डि आर मार्ग",
        english: "option_67",
        value: "option_67",
    },
    {
        nepali: "न्यौपाने चोक हुदै बाघझोडा मार्ग",
        english: "option_68",
        value: "option_68",
    },
    {
        nepali: "नटुवा डाँडा मार्ग",
        english: "option_69",
        value: "option_69",
    },
    {
        nepali: "बासुकी मार्ग गहिरी टोल",
        english: "option_70",
        value: "option_70",
    },
    {
        nepali: "विष्णुलाल मार्ग",
        english: "option_71",
        value: "option_71",
    },
    {
        nepali: "सुन्निमा मार्ग",
        english: "option_72",
        value: "option_72",
    },
    {
        nepali: "महेन्द्र मार्ग रुपाटार",
        english: "option_73",
        value: "option_73",
    },
    {
        nepali: "शान्ति मार्ग बाघझोडा",
        english: "option_74",
        value: "option_74",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const toleWardEleven = [
    {
        nepali: "माथिल्लो कर्जुना",
        english: "maathilo_kajurna",
        value: "maathilo_kajurna",
    },
    {
        nepali: "तल्लो कर्जुना",
        english: "talo_kajurna",
        value: "talo_kajurna",
    },
    {
        nepali: "ग्रमथान",
        english: "gramthan",
        value: "gramthan",
    },
    {
        nepali: "बेलेपुर",
        english: "belepur",
        value: "belepur",
    },
    {
        nepali: "सगरमाथा टोल",
        english: "sagarmatha_tol",
        value: "sagarmatha_tol",
    },
    {
        nepali: "पुरानो बेलेपुर टोल",
        english: "purano_bele_tol",
        value: "purano_bele_tol",
    },
    {
        nepali: "तीनपैनी टोल",
        english: "tinpaini_tol",
        value: "tinpaini_tol",
    },
    {
        nepali: "भुटाइ र धाती टोल",
        english: "bhutai_ra_dhati_tol",
        value: "bhutai_ra_dhati_tol",
    },
    {
        nepali: "तिनमोहडी टोल",
        english: "tinmohadi_tol",
        value: "tinmohadi_tol",
    },
    {
        nepali: "शुक्रबारे टोल",
        english: "sukharbare_tol",
        value: "sukharbare_tol",
    },
    {
        nepali: "लालिगुरास तथा पत्थरघट्ट",
        english: "laliguras_tol",
        value: "laliguras_tol",
    },
    {
        nepali: "गोविन्दपुर टोल",
        english: "gobindapur_tol",
        value: "gobindapur_tol",
    },
    {
        nepali: "शिब मन्दिर टोल",
        english: "shiva_mandir_tol",
        value: "shiva_mandir_tol",
    },
    {
        nepali: "शान्ति टोल",
        english: "santi_tol",
        value: "santi_tol",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const toleWardTwelve = [
    {
        nepali: "खोर्साने टोल विकास संस्था",
        english: "khorsane_tol",
        value: "khorsane_tol",
    },
    {
        nepali: "क्याम्पस टोल विकास संस्था",
        english: "campus_tol",
        value: "campus_tol",
    },
    {
        nepali: "सिद्धश्वर टोल विकास संस्था",
        english: "sidrasor_tol",
        value: "sidrasor_tol",
    },
    {
        nepali: "संगम टोल विकास संस्था",
        english: "sangam_tol",
        value: "sangam_tol",
    },
    {
        nepali: "प्रणाम टोल विकास संस्था",
        english: "pranam_tol",
        value: "pranam_tol",
    },
    {
        nepali: "अन्य",
        english: "others",
        value: "others",
    },
];

export const wardList = [
    {
        nepali: "वडा न.१",
        english: "Ward number 1",
        value: "1",
    },
    {
        nepali: "वडा न.२",
        english: "Ward number 2",
        value: "2",
    },
    {
        nepali: "वडा न.३",
        english: "Ward number 3",
        value: "3",
    },
    {
        nepali: "वडा न.४",
        english: "Ward number 4",
        value: "4",
    },
    {
        nepali: "वडा न.५",
        english: "Ward number 5",
        value: "5",
    },
    {
        nepali: "वडा न.६",
        english: "Ward number 6",
        value: "6",
    },
    {
        nepali: "वडा न.७",
        english: "Ward number 7",
        value: "7",
    },
    {
        nepali: "वडा न.८",
        english: "Ward number 8",
        value: "8",
    },
    {
        nepali: "वडा न.९",
        english: "Ward number 9",
        value: "9",
    },
    {
        nepali: "वडा न.१०",
        english: "Ward number 10",
        value: "10",
    },
    {
        nepali: "वडा न.११",
        english: "Ward number 11",
        value: "11",
    },
    {
        nepali: "वडा न.१२",
        english: "Ward number 12",
        value: "12",
    },
];
